var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-actions', {
    attrs: {
      "no-actions": true,
      "title": "List Barang"
    }
  }, [_vm.cek.length > 0 ? [_c('b-button', {
    staticClass: "mb-1 mr-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.modalEditKomisi();
      }
    }
  }, [_vm._v("Update Komisi (" + _vm._s(this.cek.length == 0 ? null : this.cek.length) + ")")]), _c('b-button', {
    staticClass: "mb-1",
    attrs: {
      "variant": "outline-success"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.modalEditPoin();
      }
    }
  }, [_vm._v("Update Poin (" + _vm._s(this.cek.length == 0 ? null : this.cek.length) + ")")])] : [_c('b-button', {
    staticClass: "mb-1 mr-2",
    attrs: {
      "disabled": "",
      "variant": "primary"
    }
  }, [_vm._v("Update Komisi ")]), _c('b-button', {
    staticClass: "mb-1 mr-2",
    attrs: {
      "disabled": "",
      "variant": "success"
    }
  }, [_vm._v("Update Poin ")])], _c('b-button', {
    staticClass: "mb-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.modalAturtarget();
      }
    }
  }, [_vm._v("Atur Target Komisi Bulanan dan Konversi Poin ")]), _c('header', {
    staticClass: "mb-1"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2",
      "sm": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": _vm.$t('Per page'),
      "label-size": "sm",
      "label-for": "perPageSelect",
      "size": "sm"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function ($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), !_vm.isCabang ? _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Pilih Affiliator",
      "label-for": "is_member"
    }
  }, [_c('b-input-group', [_c('b-form-select', {
    attrs: {
      "size": "sm",
      "id": "is_member",
      "options": _vm.optis_member
    },
    on: {
      "input": function ($event) {
        return _vm.getData();
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("-- Semua --")])];
      },
      proxy: true
    }], null, false, 437768337),
    model: {
      value: _vm.is_member,
      callback: function ($$v) {
        _vm.is_member = $$v;
      },
      expression: "is_member"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "sm": "2"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": _vm.$t('Filter'),
      "label-size": "sm",
      "label-for": "filterInput",
      "size": "sm"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Tekan enter untuk cari",
      "size": "sm"
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.getData();
      }
    },
    model: {
      value: _vm.filter,
      callback: function ($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.getData();
      }
    }
  }, [_vm._v(" Cari ")])], 1)], 1)], 1)], 1)], 1)], 1), _c('b-table', {
    attrs: {
      "small": "",
      "responsive": "",
      "per-page": _vm.perPage,
      "items": _vm.items,
      "fields": _vm.fieldsOwner
    },
    scopedSlots: _vm._u([{
      key: "thead-top",
      fn: function (data) {
        return [_c('b-tr', [_c('b-th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "5"
          }
        }, [_vm._v("Barang")]), _c('b-th', {
          staticClass: "text-center",
          staticStyle: {
            "background-color": "yellowgreen"
          },
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Komisi")]), _c('b-th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Komisi Cabang")]), _c('b-th', {
          staticClass: "text-center",
          staticStyle: {
            "background-color": "yellow"
          },
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Poin")])], 1)];
      }
    }, {
      key: "cell(harga_dasar)",
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" Rp. " + _vm._s(_vm.formatRupiah(item.harga_dasar)) + " ")];
      }
    }, {
      key: "cell(cek)",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('b-form-checkbox', {
          attrs: {
            "value": item
          },
          model: {
            value: _vm.cek,
            callback: function ($$v) {
              _vm.cek = $$v;
            },
            expression: "cek"
          }
        })];
      }
    }, {
      key: "cell(no)",
      fn: function (_ref3) {
        var index = _ref3.index;
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "cell(komisi_affiliate)",
      fn: function (_ref4) {
        var value = _ref4.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.type == "nominal" ? ("" + (_vm.formatRupiah(value.value))) : ((value.value) + "%")) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(sisa)",
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('b', [_vm._v(" " + _vm._s(_vm.formatRupiah(item.share_jasa - (parseInt(item.komisi_vendor ? _vm.unFormatRupiah(item.komisi_vendor.value) : 0) + parseInt(item.komisi_affiliate ? _vm.unFormatRupiah(item.komisi_affiliate.value) : 0) + parseInt(item.komisi_cabang ? _vm.unFormatRupiah(item.komisi_cabang.value) : 0) + parseInt(item.komisi_bulanan ? _vm.unFormatRupiah(item.komisi_bulanan.value) : 0) + parseInt(item.share_jasa_cabang ? _vm.unFormatRupiah(item.share_jasa_cabang.value) : 0) + parseInt(item.poin ? _vm.unFormatRupiah(item.poin.value) * (_vm.itemtarget[1] ? _vm.itemtarget[1].value : 0) : 0) + parseInt(item.poin_karyawan ? _vm.unFormatRupiah(item.poin_karyawan.value) * (_vm.itemtarget[1] ? _vm.itemtarget[1].value : 0) : 0) + parseInt(item.poin_konsumen ? _vm.unFormatRupiah(item.poin_konsumen.value) * (_vm.itemtarget[1] ? _vm.itemtarget[1].value : 0) : 0)))) + " ")])];
      }
    }, {
      key: "cell(share_jasa)",
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(_vm.formatRupiah(item.share_jasa)) + " ")];
      }
    }, {
      key: "cell(komisi_cabang)",
      fn: function (_ref7) {
        var value = _ref7.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.type == "nominal" ? ("" + (_vm.formatRupiah(value.value))) : ((value.value) + "%")) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(komisi_vendor)",
      fn: function (_ref8) {
        var value = _ref8.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.type == "nominal" ? ("" + (_vm.formatRupiah(value.value))) : ((value.value) + "%")) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(share_jasa_cabang)",
      fn: function (_ref9) {
        var value = _ref9.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.type == "nominal" ? ("" + (_vm.formatRupiah(value.value))) : ((value.value) + "%")) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(komisi_bulanan)",
      fn: function (_ref10) {
        var value = _ref10.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.type == "nominal" ? ("" + (_vm.formatRupiah(value.value))) : ((value.value) + "%")) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(poin)",
      fn: function (_ref11) {
        var value = _ref11.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.value) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(poin_karyawan)",
      fn: function (_ref12) {
        var value = _ref12.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.value) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(poin_konsumen)",
      fn: function (_ref13) {
        var value = _ref13.value;
        return [value ? _c('b', [_vm._v(" " + _vm._s(value.value) + " ")]) : _c('b', [_vm._v("-")])];
      }
    }, {
      key: "cell(action)",
      fn: function (_ref14) {
        var item = _ref14.item,
          index = _ref14.index;
        return [_c('section', {
          staticClass: "d-flex justify-content-center"
        }, [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "id": ("delete-btn-" + (item.id)),
            "size": "sm",
            "variant": "gradient-primary"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.modalEditKomisiPoin(item);
            }
          }
        }, [_vm._v("Update Komisi Dan Poin ")])], 1)];
      }
    }])
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "centered": "",
      "size": "lg",
      "id": "editKomisiPoin",
      "title": "Ubah Komisi Dan Poin",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.simpanKomisiPoin($event);
            }
          }
        }, [_vm._v("Simpan")])];
      },
      proxy: true
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h4', [_vm._v("Batas Komisi / Payout")]), _c('hr'), _c('h4', [_vm._v(_vm._s(_vm.formatRupiah(_vm.formKomisiPoin.share_jasa)))])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h4', [_vm._v("Total Komisi yang terhitung")]), _c('hr'), _c('h4', [_vm._v(_vm._s(_vm.formatRupiah(_vm.formKomisiPoin.total)))])])], 1), _c('hr'), _c('h5', [_vm._v("Komisi Vendor")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_vendor.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('komisi_vendor');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_vendor.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.value"
    }
  })], 1)], 1)], 1)], 1), _c('hr'), _c('h5', [_vm._v("Komisi Affiliate")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_affiliate.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('komisi_affiliate');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_affiliate.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.value"
    }
  })], 1)], 1)], 1)], 1), _c('hr'), _c('h5', [_vm._v("Komisi Cabang")]), _c('center', [_c('u', {
    staticClass: "text-center"
  }, [_vm._v("Utama")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_cabang.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('komisi_cabang');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_cabang.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.value"
    }
  })], 1)], 1)], 1)], 1), _c('center', [_c('u', {
    staticClass: "text-center"
  }, [_vm._v("Share")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "type", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.share_jasa_cabang.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('share_jasa_cabang');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.value"
    }
  })], 1) : _vm.formKomisiPoin.share_jasa_cabang.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.value"
    }
  })], 1)], 1)], 1)], 1), _c('hr'), _c('h5', [_vm._v("Komisi Bulanan")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_bulanan.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('komisi_bulanan');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_bulanan.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.value"
    }
  })], 1)], 1)], 1)], 1), _c('hr'), _c('h5', [_vm._v("Poin (1 Poin = " + _vm._s(_vm.itemtarget[1] ? _vm.itemtarget[1].value : 0) + ")")]), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "4",
      "lg": "4",
      "md": "4",
      "sm": "12"
    }
  }, [_c('h5', [_vm._v("Poin Affiliate")]), _c('b-form-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Poin"
    },
    on: {
      "keyup": function ($event) {
        return _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.poin.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.poin, "value", $$v);
      },
      expression: "formKomisiPoin.poin.value"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "xl": "4",
      "lg": "4",
      "md": "4",
      "sm": "12"
    }
  }, [_c('h5', [_vm._v("Poin Karyawan")]), _c('b-form-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Poin"
    },
    on: {
      "keyup": function ($event) {
        return _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.poin_karyawan.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.poin_karyawan, "value", $$v);
      },
      expression: "formKomisiPoin.poin_karyawan.value"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "xl": "4",
      "lg": "4",
      "md": "4",
      "sm": "12"
    }
  }, [_c('h5', [_vm._v("Poin Konsumen")]), _c('b-form-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Poin"
    },
    on: {
      "keyup": function ($event) {
        return _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.poin_konsumen.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.poin_konsumen, "value", $$v);
      },
      expression: "formKomisiPoin.poin_konsumen.value"
    }
  })], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "centered": "",
      "size": "lg",
      "id": "editKomisi",
      "title": "Ubah Komisi ",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.simpanKomisi($event);
            }
          }
        }, [_vm._v("Simpan")])];
      },
      proxy: true
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h4', [_vm._v("Batas Komisi / Payout")]), _c('hr'), _c('h4', [_vm._v(_vm._s(_vm.formatRupiah(_vm.formKomisiPoin.share_jasa)))])])], 1), _c('hr'), _c('h5', [_vm._v("Komisi Vendor")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_vendor.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        return _vm.doFormatHarga('komisi_vendor');
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_vendor.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_vendor.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_vendor, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_vendor.value"
    }
  })], 1)], 1)], 1)], 1), _c('hr'), _c('h5', [_vm._v("Komisi Affiliate")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_affiliate.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        return _vm.doFormatHarga('komisi_affiliate');
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_affiliate.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_affiliate.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_affiliate, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_affiliate.value"
    }
  })], 1)], 1)], 1)], 1), _c('hr'), _c('h5', [_vm._v("Komisi Cabang")]), _c('center', [_c('u', {
    staticClass: "text-center"
  }, [_vm._v("Utama")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_cabang.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('komisi_cabang');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_cabang.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_cabang.value"
    }
  })], 1)], 1)], 1)], 1), _c('center', [_c('u', {
    staticClass: "text-center"
  }, [_vm._v("Share")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "type", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.share_jasa_cabang.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('share_jasa_cabang');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.value"
    }
  })], 1) : _vm.formKomisiPoin.share_jasa_cabang.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.share_jasa_cabang.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.share_jasa_cabang, "value", $$v);
      },
      expression: "formKomisiPoin.share_jasa_cabang.value"
    }
  })], 1)], 1)], 1)], 1), _c('hr'), _c('h5', [_vm._v("Komisi Bulanan")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
        value: 'nominal',
        text: 'Nominal'
      }, {
        value: 'percentage',
        text: 'Persentase'
      }]
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.type,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "type", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai"
    }
  }, [_vm.formKomisiPoin.komisi_bulanan.type == 'nominal' ? _c('b-input-group', {
    staticClass: "input-group-merge",
    attrs: {
      "prepend": "Rp."
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nominal Komisi"
    },
    on: {
      "keyup": function ($event) {
        _vm.doFormatHarga('komisi_bulanan');
        _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.value"
    }
  })], 1) : _vm.formKomisiPoin.komisi_bulanan.type == 'percentage' ? _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Persentase Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.value"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("%")])], 1) : _c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Nominal Komisi"
    },
    model: {
      value: _vm.formKomisiPoin.komisi_bulanan.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.komisi_bulanan, "value", $$v);
      },
      expression: "formKomisiPoin.komisi_bulanan.value"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "centered": "",
      "size": "lg",
      "id": "editPoin",
      "title": "Ubah Poin",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.simpanPoin($event);
            }
          }
        }, [_vm._v("Simpan")])];
      },
      proxy: true
    }])
  }, [_c('h5', [_vm._v("Poin")]), _c('b-form-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Poin"
    },
    on: {
      "keyup": function ($event) {
        return _vm.cekharga();
      }
    },
    model: {
      value: _vm.formKomisiPoin.poin.value,
      callback: function ($$v) {
        _vm.$set(_vm.formKomisiPoin.poin, "value", $$v);
      },
      expression: "formKomisiPoin.poin.value"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "centered": "",
      "size": "lg",
      "id": "aturpoin",
      "title": "Atur Poin",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.simpanaturPoin($event);
            }
          }
        }, [_vm._v("Simpan")])];
      },
      proxy: true
    }])
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', [_c('h2', [_vm._v("Ubah Nilai Konversi Poin")]), _c('b-form-input', {
    attrs: {
      "size": "lg",
      "placeholder": "Poin"
    },
    model: {
      value: _vm.nilai_konversi,
      callback: function ($$v) {
        _vm.nilai_konversi = $$v;
      },
      expression: "nilai_konversi"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', [_c('h2', [_vm._v("Nilai Konversi Poin")]), _c('h3', [_vm._v(_vm._s(_vm.itemnilaikonversi ? _vm.formatRupiah(_vm.itemnilaikonversi.nilai_konversi) : 0))])])], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "id": "aturtarget",
      "size": "lg",
      "ok-variant": "secondary",
      "centered": "",
      "title": "Atur Target Komisi Bulanan dan Konversi Poin"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "xl": "12",
      "lg": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "xl": "3",
      "lg": "3",
      "md": "3",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipe",
      "label-for": "v-teritori"
    }
  }, [_c('b-form-select', {
    attrs: {
      "reduce": function (option) {
        return option.value;
      },
      "label": "text",
      "options": _vm.opttypetarget
    },
    model: {
      value: _vm.formtarget.type,
      callback: function ($$v) {
        _vm.$set(_vm.formtarget, "type", $$v);
      },
      expression: "formtarget.type"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "xl": "3",
      "lg": "3",
      "md": "3",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nilai",
      "label-for": "v-value"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.formtarget.value,
      callback: function ($$v) {
        _vm.$set(_vm.formtarget, "value", $$v);
      },
      expression: "formtarget.value"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "xl": "2",
      "lg": "2",
      "md": "2",
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "-",
      "label-for": "v-value"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.submittarget($event);
      }
    }
  }, [_vm._v(" Simpan ")])], 1)], 1)], 1), _c('b-table', {
    attrs: {
      "small": "",
      "items": _vm.itemtarget,
      "fields": [{
        key: 'name',
        label: 'Nama'
      }, {
        key: 'value',
        label: 'Nilai'
      }]
    }
  })], 1)], 1)], 1)], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }